import React from "react";
const GlobalContext = React.createContext(null);
export const GlobalProvider = GlobalContext.Provider;
export default GlobalContext;
